<template>
  <div :class="origin == 'buildings'?'col-sm-4':'col-sm-4'">Facing orientation(s)</div>
  <div :class="origin == 'buildings'?'col-sm-8':'col-sm-8'">
    <div class="row modspec_font10">
      <div class="col form-check">
        <input class="form-check-input" type="checkbox" name="grdOrientationNorth" id="chkNorth" value="1"
          v-model="orientation.north" @change="changeOrientation" />
        <label class="form-check-label modspec_font12" for="chkNorth"> North </label>
      </div>
      <div class="col form-check">
        <input class="form-check-input" type="checkbox" name="grdOrientationEast" id="chkEast" value="1"
          v-model="orientation.east" @change="changeOrientation" />
        <label class="form-check-label modspec_font12" for="chkEast"> East </label>
      </div>
      <div class="col form-check">
        <input class="form-check-input" type="checkbox" name="grdOrientationSouth" id="chkSouth" value="1"
          v-model="orientation.south" @change="changeOrientation" />
        <label class="form-check-label modspec_font12" for="chkSouth"> South </label>
      </div>
      <div class="col form-check">
        <input class="form-check-input" type="checkbox" name="grdOrientationWest" id="chkWest" value="1"
          v-model="orientation.west" @change="changeOrientation" />
        <label class="form-check-label modspec_font12" for="chkWest"> West </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "nq-orientation",
  props: ['origin'],
  data: function () {
    return {
      orientation: { north: false, south: false, east: false, west: false },
      //number:0
    };
  },
  mounted() { 
  },
  methods: {
    reset() {
      this.orientation = {
        north: false,
        south: false,
        east: false,
        west: false,
      };
      this.$emit("setOrientation", {number:0,orientations:''});
    },
    setOrientationValue(value) {
      const orientations = typeof value === "string" ? value : value?.orientations || "";
      this.orientation = {
        north: orientations.includes("N"),
        south: orientations.includes("S"),
        east: orientations.includes("E"),
        west: orientations.includes("W"),
      };
      this.changeOrientation();
    },
    changeOrientation() {
      let o = {number:0,orientations:''};
      
      if (this.orientation.north){
        o.number += 1;
        o.orientations += 'N,';
      } 
      if (this.orientation.south){
        o.number += 1;
        o.orientations += 'S,';
      }
      if (this.orientation.east){
        o.number += 1;
        o.orientations += 'E,';
      }
      if (this.orientation.west){
        o.number += 1;
        o.orientations += 'W,';
      }
      
      o.orientations=o.orientations.replace(/.$/,"");

      this.$emit("setOrientation", o);
    },
  },
};
</script>
<style scoped>
.form-check-input {
  width: 1.5em;
  height: 1.5em;
  margin-left: -5px !important;
}

.form-check-label {
  margin-left: 5px;
}

@media only screen and (max-width: 575px) and (max-width: 991px) {
  .form-check-input {
    margin-left: 0px !important;
  }
}
</style>
